import { render, staticRenderFns } from "./cultureHeritage.vue?vue&type=template&id=2ae03c84&scoped=true&"
import script from "./cultureHeritage.vue?vue&type=script&lang=ts&"
export * from "./cultureHeritage.vue?vue&type=script&lang=ts&"
import style0 from "./cultureHeritage.vue?vue&type=style&index=0&id=2ae03c84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae03c84",
  null
  
)

export default component.exports